module.exports = "<p>\n  actionchoice works!\n</p>\n"